import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  pruefeTresorStatus,
  sperren,
  selectTresorStatus,
} from 'core/features/sicherheit/sicherheitSlice';
import VaultSetup from 'core/features/sicherheit/VaultSetup';
import VaultUnlock from 'core/features/sicherheit/VaultUnlock';

/**
 * Panel fuer den "gesicherten Modus" oben auf der Uebersicht. Je nach Tresor-
 * Status: einrichten (absent), entsperren (locked) oder aktiver Zustand mit
 * Sperren-Knopf (unlocked). Nur im gesicherten Modus sind gesicherte Bereiche
 * (Wissen, Investitionen, ...) erreichbar.
 */
export default function SicherheitPanel() {
  const dispatch = useDispatch();
  const status = useSelector(selectTresorStatus);
  const [offen, setOffen] = useState(false);

  // Verschluesselung braucht einen Secure Context (HTTPS/localhost).
  const kryptoVerfuegbar = typeof window !== 'undefined' && window.crypto && window.crypto.subtle;

  useEffect(() => {
    if (kryptoVerfuegbar && status === 'unknown') dispatch(pruefeTresorStatus());
  }, [dispatch, kryptoVerfuegbar, status]);

  if (!kryptoVerfuegbar) return null;
  if (status === 'unknown') return null;

  if (status === 'unlocked') {
    return (
      <div className="mx-auto mb-10 flex max-w-md items-center justify-between gap-3 rounded-xl border border-emerald-300/60 bg-emerald-50 px-4 py-3">
        <span className="text-sm font-medium text-emerald-800">🔓 Gesicherter Modus aktiv</span>
        <button
          type="button"
          onClick={() => dispatch(sperren())}
          className="rounded-lg border border-emerald-300 px-3 py-1.5 text-sm font-medium text-emerald-800 transition-colors hover:bg-emerald-100"
        >
          Sperren
        </button>
      </div>
    );
  }

  const einrichten = status === 'absent';

  return (
    <div className="mx-auto mb-10 max-w-md">
      {!offen ? (
        <button
          type="button"
          onClick={() => setOffen(true)}
          className="flex w-full items-center justify-center gap-2 rounded-xl border border-line bg-paper px-4 py-3 text-sm font-medium text-ink shadow-sm transition-colors hover:bg-ink/5"
        >
          {einrichten ? '🔐 Gesicherten Modus einrichten' : '🔒 Gesicherten Modus entsperren'}
        </button>
      ) : (
        <div>
          {einrichten ? <VaultSetup /> : <VaultUnlock />}
          <button
            type="button"
            onClick={() => setOffen(false)}
            className="mt-3 w-full text-center text-sm text-ink-muted hover:underline"
          >
            Abbrechen
          </button>
        </div>
      )}
    </div>
  );
}
